/**
 * Created by jimmy on 2019/9/29.
 */

import React, { useState, useEffect } from 'react';
import moment from 'moment';

import * as Request from '../../common/request';
import * as Utils from '../../common/utils';
import * as Const from '../../common/const';
import Page from '../../components/page';

import './index.less';

import IMG_ZAN from '../../common/images/zan.png';
import IMG_READ_COUNT from '../../common/images/read-count.png';
import IMG_POI from '../../common/images/poi.png';
import IMG_AVATAR_DEFAULT from '../../common/images/avatar-default.png';

const PageModel = props => {
	const [ list, setList ] = useState([]);
	const getList = async () => {
		const result = await Request.get({
			url: '/user/problem/list'
		});
		if(!result) return;

		setList(result.data.list || []);
	};
	useEffect(() => {
		getList();
	}, [ 123 ]);

	return (
		<Page title="上报的问题">
			<section className="report-list-container">
				{
					list && list.length > 0 && list.map((item, idx) => {
						return (
							<div className="list-item" key={idx} onClick={() => {
								props.history.push(`/user/report/${item.id}`);
							}}>
								<div className="item-wrap">
									<div className="item"><label>记录编号：</label><span>{item.number.substr(0, 10)}</span></div>
									<div className="item"><label>创建时间：</label><span>{item.createdAt && moment(item.createdAt).format('YYYY.MM.DD')}</span></div>
								</div>
								<div className="item-wrap">
									<div className="item"><label>问题描述：</label><span>{item.content}</span></div>
									<div className="status">{Const.problemStatusDisplayMap[item.status]}</div>
								</div>
							</div>
						)
					})
				}
			</section>
		</Page>
	);
};

export default PageModel;
